export default __webpack_public_path__ + "static/media/landin-blockimg14.03aa4c65.png";